import { getItem } from "@/utils/storage";

export const permissionsService = {

  loadUserPermissions() {
    try {
      const teamMember = getItem("team_member");

      if (!teamMember) {
        console.log('No team member found - assuming admin access');
        return ['*']; 
      }

      const permissions = teamMember.groups?.[0]?.permissions?.[0]?.actions || [];
      
      return permissions.length > 0 ? permissions : ['*'];
    } catch (error) {
      console.error("Error parsing permissions:", error);
      return ['*']; 
    }
  },

  
  hasPermission(permission) {
    const userPermissions = this.loadUserPermissions();

    if (userPermissions.includes('*')) {
      return true;
    }     

    if (typeof permission !== 'string') {
      console.warn('Invalid permission type');
      return false;
    }

    if (userPermissions.includes(permission)) {
      return true;
    }

    // if (permission.endsWith('*')) {
    //   const prefix = permission.slice(0, -1);
    //   return userPermissions.some((p) => p.startsWith(`${prefix}`));
    // }

    return false;
  }
};